import { render, staticRenderFns } from "./AgentTransactionsReportDesignList.vue?vue&type=template&id=198c37d6&"
import script from "./AgentTransactionsReportDesignList.vue?vue&type=script&lang=js&"
export * from "./AgentTransactionsReportDesignList.vue?vue&type=script&lang=js&"
import style0 from "./AgentTransactionsReportDesignList.vue?vue&type=style&index=0&id=198c37d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports